module.exports = __webpack_public_path__ + "img/cadreSurvolLarge.45d5f729.png";